/** biome-ignore-all lint/a11y/noLabelWithoutControl: This is a primitive component, there is no input/field associated with it */

import { type ComponentPropsWithoutRef, memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type LabelProps = ComponentPropsWithoutRef<'label'>;

export const Label = memo(({ className, ...restOfProps }: LabelProps) => {
  return <label className={cn('font-medium text-14 text-neutral-11', className)} {...restOfProps} />;
});

Label.displayName = 'Label';
